// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './services/store'
import router from './router'
import $ from 'jquery'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import dateUtil from "./services/utils/dateUtil";
import echarts from 'echarts'

Vue.config.productionTip = false;
/* eslint-disable no-new */
Vue.prototype.$echarts = echarts; //该项目内的组件页面使用都用this.$echarts
Vue.prototype.dateUtil = dateUtil;
Vue.config.productionTip = false;
Vue.use(ElementUI);
window.jQuery = $;
window.$ = $;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store
});
